module.exports = __webpack_public_path__ + "assets/fcb0bfe9862d09d6719ae544e157d6ac.png";